import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { URL_PARAMETERS } from 'constants/apiConstants';
import { Store } from 'types/store';

const useOneMonthFreeSearchParam = () => {
  const { pageModel } = useSelector((state: Store) => state.expiryRenewal);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (
      pageModel?.isEligibleForOneMonthFreeDiscount
      && searchParams.get(URL_PARAMETERS.ONE_MONTH_FREE) !== 'true'
    ) {
      const params = new URLSearchParams(searchParams);
      params.set(URL_PARAMETERS.ONE_MONTH_FREE, 'true');
      setSearchParams(params);
    }
  }, [pageModel, searchParams, setSearchParams]);

  return useMemo(() => {
    if (pageModel?.isEligibleForOneMonthFreeDiscount) {
      return true;
    }

    return searchParams.get(URL_PARAMETERS.ONE_MONTH_FREE) === 'true';
  }, [pageModel, searchParams]);
};

export default useOneMonthFreeSearchParam;
